import { domains } from 'config/env'

export const HEADER_TITLE = 'Middle School Units Are Changing'
export const BODY_TEXT =
  'Grades 6-8 have a new Unit 2: Developing a Positive Sense of Self. The Recognizing Bullying & Harassment unit is now supplemental'
export const BUTTON_TEXT = 'Learn More'
export const LINK_TEXT = "See What's Changing"
export const LINK_HREF = `${domains.ADMIN_DOMAIN}/license-management/expired-licenses`
